import './styles.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@edx/paragon';
import classNames from 'classnames';
import { formatRichText } from '@utils/formatting';
import ContentfulLink from '@prospectus/common/ui/ContentfulLink';
import ContentfulImage from '@prospectus/common/ui/ContentfulImage';
import { marketingBannerPropTypes, marketingBannerDefaultProps } from './propTypes';

function MarketingTakeover({
  link,
  title,
  shortDescription,
  detailedDescription,
  theme,
  image,
  bannerImage,
  className,
}) {
  return (
    <div className={classNames('marketing-takeover-container', theme, className)}>
      <Container size="lg" className="marketing-takeover">
        <div className="text-block">
          <ContentfulImage
            className="d-none d-md-block image-block"
            {...bannerImage}
            height="auto"
            lazyLoad
            additionalParams={{ q: 50 }}
          />
        </div>
        <div className="d-flex align-items-center justify-content-around">
          <div className="text-block">
            {/* eslint-disable-next-line react/no-danger */}
            <h2 className="marketing-takeover-heading" dangerouslySetInnerHTML={{ __html: title }} />
            <p className="secondary-text html_rendered_content">
              {shortDescription?.length > 0 ? shortDescription : formatRichText(detailedDescription?.raw)}
            </p>
            {link && link.url && link.label && (
            <ContentfulLink
              cta={link}
              className={classNames('btn', {
                'btn-primary': theme !== 'theme-dark',
                'btn-inverse-outline-primary': theme === 'theme-dark',
              })}
              analytics={{
                eventName: 'edx.bi.user.marketing-takeover.clicked',
              }}
            />
            )}
          </div>
          <ContentfulImage
            className="d-none d-md-block image-block"
            {...image}
            height="auto"
            lazyLoad
            additionalParams={{ q: 50 }}
          />
        </div>
      </Container>
    </div>
  );
}

MarketingTakeover.propTypes = {
  ...marketingBannerPropTypes,
  className: PropTypes.string,
};

MarketingTakeover.defaultProps = {
  ...marketingBannerDefaultProps,
  className: '',
};

export default MarketingTakeover;
